module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/valais4you-french-1e6163210bf511da4c04ad9004546a77.webp";